import { render } from "./BaseRadioGroup.vue?vue&type=template&id=53b1f652&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=53b1f652&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53b1f652"

export default script